import {ChangeTabEvent} from '../opac.directive';
import {Inject} from 'ng-metadata/core';

import {PrimoResponse} from '../../../../../infra/dataStructures/PrimoResponses/ils.interface';
import {Component, Output, Input, EventEmitter} from 'ng-metadata/core';

import serviceProviders, {RequestService} from './request.service';
import serviceProviders, {LocationsService} from '../locations/locations.service';
//your imports go here
import {OpacService, StatusMsg} from '../opac.service';

import {FormBuilderService} from '../../../../../infra/formBuilder/formBuilder.service';
import {FormBuilderEnums} from '../../../../../infra/formBuilder/formBuilder.service';
import {DateUtils} from '../../../../../nddUtils/dateUtils.service';
import {OPAC_TAB} from '../opac.directive';
import {ServiceButtonService} from '../serviceButton.service';
import {
    getVid,
    isNgrs,
    getInstitutionCode,
    getPrimoVeAlternativeEmailDigitalResourceSharing
} from '../../../../..//appConfig/appConfigForward';
import {ConfigurationUtil} from '../../../../..//nddUtils/configurationUtil.service';
import {Subscription} from "rxjs";
import {MediaQueries} from "../../../../../infra/mediaQueries.service";
import {STATE_NAMES} from '../../../../../primoExplore/primoExploreStates.module';
import {SmoothScrollUtil} from '../../../../../nddUtils/smoothScrollUtil.service';
import {AnalyticsUtils} from "../../../../../../components/nddUtils/analyticsUtils.service";


const indexOf = require('lodash/indexOf');
const filter = require('lodash/filter');
const forEach = require('lodash/forEach');
const cloneDeep = require('lodash/cloneDeep');
const get = require('lodash/get');
const isEqual = require('lodash/isEqual');


@Component({
    selector: 'prm-request',
    templateUrl: 'components/search/fullView/getit/opac/request/request.html'
})


export class PrmRequest {

    @Input() private blankService: string;
    @Input() public service;
    @Input() public isOverlayFullView: boolean;
    @Input() private item;
    @Output() private changeTabEvent: EventEmitter<ChangeTabEvent> = new EventEmitter();


    private HTML_PREFIX: string = '{include_HTML}';
    private vid: string = getVid();
    private blankRequests;
    private itemAvailability: boolean;
    private itemAvailabilityCheckInProgress: boolean;
    private formInputChangedSinceLastAvailabilityCheck: boolean = false;
    private availabilityCheckRan: boolean = false;
    private subscription: Subscription;
    private findItemLevelDescriptionsRan: boolean = false;
    private findItemLevelDescriptionsInProgress: boolean = false;
    private formSubmited: boolean = false;
    private itemDescriptionsNotEmpty;
    private isRequestSubmitted: boolean = false;

    constructor(private requestService: RequestService,
                private smoothScrollUtil: SmoothScrollUtil,
                private opacService: OpacService,
                private formBuilderService: FormBuilderService,
                private dateUtils: DateUtils,
                private serviceButtonService: ServiceButtonService,
                private locationsService: LocationsService,
                @Inject('restBaseURLs') private restBaseURLs: Object,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$scope') private $scope: ng.IScope,
                private mediaQueries: MediaQueries,
                @Inject('$state') private $state: ng.ui.IStateService,
                private analyticsUtils: AnalyticsUtils) {
        this.blankRequests = {
            'AlmaResourceSharing': {
                'allowed': "Y",
                'link-to-service': "/primaws/rest/priv/ILSServices/titleServices/-1/-1/AlmaResourceSharing?institution=",
                'service-type': "OvP",
                'type': "AlmaResourceSharing"
            },
            'AlmaPurchaseRequest': {
                'allowed': "Y",
                'link-to-service': "/primaws/rest/priv/ILSServices/titleServices/-1/-1/AlmaPurchaseRequest?institution=",
                'service-type': "OvP",
                'type': "AlmaPurchaseRequest"
            }
        };

        //subscribe to observable to know when a new form is opened
        this.subscription = this.requestService.newFormObservable.subscribe(() => {
            this.availabilityCheckRan = false;
            this.findItemLevelDescriptionsRan = false;
            if (this.isCheckAvailabilityEnabledForForm() && !this.blankService) {
                setTimeout(() => {
                    this.checkAvailability();
                }, 200);
            }
            if (this.serviceType === 'AlmaResourceSharing' && !this.blankService) {
                setTimeout(() => {
                    this.findItemLevelDescriptions();
                }, 200);
            }
        });

        //watch form data to fire handler when some input field changes
        this.$scope.$watch('$ctrl.formData', (newFormData, oldFormData) => {
            this.onFormInputChange(newFormData, oldFormData)
        }, true);
    }

    ngOnInit() {
        this.requestService.requestIsLoading = false;
        this.requestService.displayErrorMessage = false;
        this.isRequestSubmitted = false;
        if (this.blankService === 'AlmaResourceSharing') {
            this.requestService.requestIsLoading = true;
            console.log('blankService - AlmaResourceSharing');
            this.requestService.service = this.blankRequests['AlmaResourceSharing'];
            this.requestService.service['link-to-service'] = this.requestService.service['link-to-service'] + getInstitutionCode();
            let reqParams = {'vid': this.vid};
            this.serviceButtonService.makeIlsRequest(this.requestService.service, reqParams);
        }
        if (this.blankService === 'AlmaPurchaseRequest') {
            this.requestService.requestIsLoading = true;
            this.requestService.service = this.blankRequests['AlmaPurchaseRequest'];
            this.requestService.service['link-to-service'] = this.requestService.service['link-to-service'] + getInstitutionCode();
            let reqParams = {'vid': this.vid};
            this.serviceButtonService.makeIlsRequest(this.requestService.service, reqParams);
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    get serviceType(): string {
        let service = this.requestService.service;
        if (service === undefined) {
            return '';
        }
        return service.type;
    }

    get form() {
        return this.getFilteredForm([
            FormBuilderEnums.UI_TYPE.LABEL,
            FormBuilderEnums.UI_TYPE.MULTI_LABEL
        ], false);
    }

    get formReadonly() {
        return this.getFilteredForm([
            FormBuilderEnums.UI_TYPE.LABEL,
            FormBuilderEnums.UI_TYPE.MULTI_LABEL
        ], true);
    }

    get requestHeader() {
        switch (this.serviceType) {
            case 'ILL'                :
                return 'nui.ill.header';
            case 'PhotocopyRequest' :
                return 'nui.PhotocopyRequest.header';
            case 'HoldRequest'    :
                return 'nui.HoldRequest.header';
            case 'CallSlip'         :
                return 'nui.CallSlip.header';
            case 'ShortLoan'        :
                return 'nui.shortloan.header';
            case 'UBRequest'        :
                return 'nui.ubrequest.header';
            case 'Recall'            :
                return 'nui.Recall.header';
            case 'AlmaDigitization'   :
                return 'almaDigitization.header';
            case 'AlmaPurchaseRequest'   :
                return 'almaPurchaseRequest.header';
            case 'AlmaRequest'   :
                return 'almaRequest.header';
            case 'AlmaRequestAnyItem'   :
                return 'almaRequestAnyItem.header';
            case 'AlmaRequestOther'   :
                return 'almaRequestOther.header';
            case 'AlmaDigitizationOther'   :
                return 'almaDigitizationOther.header';
            case 'AlmaGeneralDigitization'   :
                return 'almaDigitization.header';
            case 'AlmaItemDigitization'   :
                return 'almaItemDigitization.header';
            case 'AlmaItemRequest'   :
                return 'almaItemRequest.header';
            case 'AlmaResourceSharing'   :
                return 'almaResourceSharing.header';
            default                 :
                return '';
        }
    }

    get requestFormDescription() {
        switch (this.serviceType) {
            case 'AlmaDigitization'   :
                return 'almaDigitization.formDescription';
            case 'AlmaItemDigitization'   :
                return 'almaDigitization.formDescription';
            case 'AlmaDigitizationOther'   :
                return 'almaDigitization.formDescription';
            case 'AlmaGeneralDigitization'   :
                return 'almaDigitization.formDescription';
            case 'AlmaPurchaseRequest'   :
                return 'almaPurchaseRequest.formDescription';
            case 'AlmaRequest'   :
                return get(this.requestService.formData, 'requestType') === 'booking' ?
                    'almaBookingRequest.formDescription' : 'almaRequest.formDescription';
            case 'AlmaItemRequest'   :
                return get(this.requestService.formData, 'requestType') === 'booking' ?
                    'almaBookingRequest.formDescription' : 'almaRequest.formDescription';
            case 'AlmaRequestAnyItem'   :
                return get(this.requestService.formData, 'requestType') === 'booking' ?
                    'almaBookingRequest.formDescription' : 'almaRequest.formDescription';
            case 'AlmaRequestOther'   :
                return 'almaRequest.formDescription';
            case 'AlmaResourceSharing'   :
                return 'almaResourceSharing.formDescription';
            default                 :
                return '';
        }
    }

    get showDescription() {
        return this.requestService.isDisplayFormDescription(this.serviceType);
    }

    get submitLabel() {
        switch (this.serviceType) {
            case 'PhotocopyRequest' :
                return 'nui.PhotocopyRequest.send';
            case 'AlmaDigitization'   :
                return 'almaDigitization.send';
            case 'AlmaDigitizationOther'   :
                return 'almaDigitization.send';
            case 'AlmaItemDigitization'   :
                return 'almaDigitization.send';
            case 'AlmaGeneralDigitization'   :
                return 'almaDigitization.send';
            default                 :
                return 'nui.request.send';
        }
    }

    get formData() {
        return this.requestService.formData;
    }

    set formData(formData) {
        this.requestService.formData = formData;
    }

    get displayForm() {

        if (this.serviceType === 'AlmaResourceSharing' && this.requestService.form.length > 0 && (!this.requestService.isBookFindItemDescriptionsEnabled || !this.itemDescriptionsNotEmpty)) {
            this.requestService.form.filter(field => {
                return field.key == 'bookDescription'
            })[0].uiType = 'hidden';
        }
        if (this.serviceType === 'AlmaResourceSharing' && this.requestService.form.length > 0 && (!this.requestService.isArticleFindItemDescriptionsEnabled || !this.itemDescriptionsNotEmpty)) {
            this.requestService.form.filter(field => {
                return field.key == 'articleDescription'
            })[0].uiType = 'hidden';
        }

        return this.getFilteredForm([
            FormBuilderEnums.UI_TYPE.LABEL,
            FormBuilderEnums.UI_TYPE.MULTI_LABEL,
            FormBuilderEnums.UI_TYPE.HIDDEN
        ], false).length > 0;
    }

    scrollToElementId(eID) {
        this.isRequestSubmitted = false;
        setTimeout(() => {
            let elm = document.getElementById(eID) as HTMLElement;
            if (!elm) {
                return
            }
            if (this.isOverlayFullView) {
                this.smoothScrollUtil.scrollTo(eID, '', 'sticky-scroll');
            } else {
                this.smoothScrollUtil.scrollTo(eID, '', '');
            }
            elm.focus();
        }, 500);
    }

    /* public functions */
    public submit(isValid) {
        let service: PrimoResponse.Ils.IRequestService = cloneDeep(this.requestService.service);
        let postData = cloneDeep(this.formData);

        if (this.serviceType === "AlmaResourceSharing") {
            if (window.location.pathname.indexOf('openurl') !== -1) { // this request came from openurl, and should be noted accordingly
                postData.openUrl = window.location.href;
            }

            if (getPrimoVeAlternativeEmailDigitalResourceSharing() && this.getFilteredForm(["hidden"], true).filter(el => {
                return "alternativeLocationEmail" === el.key
            }).length > 0) {
                this.opacService.responseStatus = new StatusMsg(false, "the request could not be completed due to configuration issue - please contact your library");
                let eventData: ChangeTabEvent = {
                    referer: OPAC_TAB.REQUEST,
                    dest: OPAC_TAB.RESPONSE,
                };
                this.changeTabEvent.emit(eventData);
                return;
            }
        }

        if (!postData.group_id) { //set it as ILS API ID
            postData.group_id = this.requestService.ilsApiId;
        }

        let itemId = postData.item_id || postData['request-option'];
        if (itemId) { //special case - request by item level
            /* update API to item level */
            service['link-to-service'] = service['link-to-service'] + '/item/' + itemId;
        }

        let itemId = postData.item_id || postData.itemId || this.serviceType === "AlmaPurchaseRequest";
        if (!itemId) { //If we are not item level we don't request specific material type
            delete postData.materialType;
        }

        if (this.blankService === "AlmaPurchaseRequest" && get(postData, 'citationType') === 'book' && get(postData, 'isbn')) {
            // We want the server to check if a match for the ISBN already exists in the library for blank purchase requests
            service['link-to-service'] = service['link-to-service'] + '&checkForISBN=true';
        }

        this.manipulatePostData(postData);
        let mmsId = itemId ? undefined : postData.group_id;
        this.formSubmited = true;
        service['link-to-service'] = service['link-to-service'] + '&lang=' + this.$translate.use();
        this.sendAnalytics();
        this.opacService.makeIlsCall(service, postData, 'POST')
            .then((res) => {
                this.opacService.responseStatus = new StatusMsg(res.status === 'ok', res['reply-text'], res.adjustedStartTime, res.adjustedEndTime);
                let eventData: ChangeTabEvent = {
                    referer: OPAC_TAB.REQUEST,
                    dest: (res.status === 'requires_approval' ? OPAC_TAB.APPROVAL : OPAC_TAB.RESPONSE),
                    itemId: itemId,
                    mmsId: mmsId
                };
                this.isRequestSubmitted = true;
                this.formSubmited = false;
                this.changeTabEvent.emit(eventData);

            }).finally(() => {
            this.formSubmited = false;
        });
    }

    public resetForm() {
        this.requestService.setupNewForm(this.requestService.service, this.requestService.ilsData, true);
    }

    public autoFill(fieldName) {
        let clonedFormData = cloneDeep(this.formData);
        if ((fieldName == 'doi' && clonedFormData.doi)
            || (fieldName == 'pmid' && clonedFormData.pmid)) {
            let autoFillId = fieldName == 'doi' ? clonedFormData.doi : clonedFormData.pmid;
            let service = {} as PrimoResponse.Ils.IRequestService;
            service['link-to-service'] = "/primaws/rest/priv/ILSServices/titleServices/autoFill/" + fieldName + "?autoFillId=" + autoFillId;
            this.requestService.requestIsLoading = true;
            this.opacService.makeIlsCall(service)
                .then((res) => {
                    this.removeAlerts();
                    if (Object.keys(res).length > 1) {
                        this.fillInAutoFillValues(res);
                    } else {
                        this.addAlert(fieldName);
                    }
                }).finally(() => {
                this.requestService.requestIsLoading = false;
            });
        }
    }

    public isLabelIncludeHtml(label) {
        return label.indexOf(this.HTML_PREFIX) === 0;
    }

    public removeLabelHtmlPrefix(label) {
        return label.substr(this.HTML_PREFIX.length);
    }

    private addAlert(fieldName) {
        let autoFillDidNotSucceedLabel = this.$translate.instant('almaResourceSharing.autoFillDidNotSucceed');
        if (fieldName == 'doi') {
            this.requestService.form.find(obj => obj.key == 'doi').msg = autoFillDidNotSucceedLabel;
        } else {
            this.requestService.form.find(obj => obj.key == 'pmid').msg = autoFillDidNotSucceedLabel;
        }
    }

    private removeAlerts() {
        delete this.requestService.form.find(obj => obj.key == 'doi').msg;
        delete this.requestService.form.find(obj => obj.key == 'pmid').msg;
    }

    private fillInAutoFillValues(res) {
        if (this.form.find(obj => (obj.key == 'articleTitle' && obj.uiType != "hidden"))) {
            this.requestService.formData.articleTitle = res.articleTitle;
        }

        if (this.form.find(obj => (obj.key == 'journalTitle' && obj.uiType != "hidden"))) {
            this.requestService.formData.journalTitle = res.journalTitle;
        }

        if (this.form.find(obj => (obj.key == 'author' && obj.uiType != "hidden"))) {
            this.requestService.formData.author = res.author;
        }

        if (this.form.find(obj => (obj.key == 'journalVolume' && obj.uiType != "hidden"))) {
            this.requestService.formData.journalVolume = res.volume;
        }

        if (this.form.find(obj => (obj.key == 'issue' && obj.uiType != "hidden"))) {
            this.requestService.formData.issue = res.issue;
        }

        if (this.form.find(obj => (obj.key == 'issn' && obj.uiType != "hidden"))) {
            this.requestService.formData.issn = res.issn;
        }

        if (this.form.find(obj => (obj.key == 'pagesToPhotocopy' && obj.uiType != "hidden"))) {
            this.requestService.formData.pagesToPhotocopy = res.pages;
        }

        if (this.form.find(obj => (obj.key == 'startPage' && obj.uiType != "hidden"))) {
            this.requestService.formData.startPage = res.sPage;
        }

        if (this.form.find(obj => (obj.key == 'endPage' && obj.uiType != "hidden"))) {
            this.requestService.formData.endPage = res.ePage;
        }

        if (this.form.find(obj => (obj.key == 'publicationDate' && obj.uiType != "hidden"))) {
            this.requestService.formData.publicationDate = res.publicationYear;
        }
    }

    private getFilteredForm(filters, isExists) {
        if (!this.requestService.form) {
            return [];
        }

        if (this.$state.current.name === STATE_NAMES.BLANK_ILL)
            this.addDoiAndPmidAutoCompleteIfNeeded();

        return this.requestService.form.filter((el) => {
            return isExists ? indexOf(filters, el.uiType) > -1 : indexOf(filters, el.uiType) < 0;
        });
    }

    private addDoiAndPmidAutoCompleteIfNeeded() {
        if (this.requestService.form.find(obj => obj.key == 'doi')) {
            this.requestService.form.find(obj => obj.key == 'doi').doiAutoFill = this.requestService.mappingTablesCache
                .findByProperties(this.requestService.mappingTablePerService.AlmaResourceSharing, {
                    source2: 'doiAutoFill',
                    target: 'Yes'
                })
                .length > 0 && get(this.requestService.ilsData, 'services-arr.services[0].doiAutoFillAllowed', false);
            this.requestService.form.find(obj => obj.key == 'doi').autoFillAriaLabel = this.$translate.instant('nui.aria.rshForm.doiAutoFillAriaLabel');
        }
        if (this.requestService.form.find(obj => obj.key == 'pmid')) {
            this.requestService.form.find(obj => obj.key == 'pmid').pmidAutoFill = this.requestService.mappingTablesCache
                .findByProperties(this.requestService.mappingTablePerService.AlmaResourceSharing, {
                    source2: 'pmidAutoFill',
                    target: 'Yes'
                })
                .length > 0 && get(this.requestService.ilsData, 'services-arr.services[0].pmidAutoFillAllowed', false);
            this.requestService.form.find(obj => obj.key == 'pmid').autoFillAriaLabel = this.$translate.instant('nui.aria.rshForm.pmidAutoFillAriaLabel');
        }
    }

    private manipulatePostData(postData) {
        forEach(postData, (value, key) => {
            let field = this.getFieldByName(this.requestService.form, key);
            if (field) {
                if (field.fieldType === FormBuilderEnums.FIELD_TYPE.INTERNAL) {
                    delete postData[key];
                    return;
                }
                this.manipulateDatePostData(postData, field, key);
            }
            if (key === "pickupLocation" || key === "pickupLocationFulNet") {
                if (postData[key].indexOf("$$") !== -1) {
                    let pickupLocation = postData[key].slice(0, postData[key].indexOf("$"));
                    let pickupLocationType = postData[key].slice(postData[key].indexOf("$$") + 2);
                    postData[key] = pickupLocation;
                    postData["pickupLibraryId"] = pickupLocation;
                    if (pickupLocationType && pickupLocationType.indexOf("###") !== -1) {
                        let userAddressId = pickupLocationType.slice(pickupLocationType.indexOf("###") + 3);
                        postData["userAddressId"] = userAddressId;
                        pickupLocationType = pickupLocationType.slice(0, pickupLocationType.indexOf("#"));
                    }
                    postData["pickupType"] = pickupLocationType;
                }
            }
        });
    }

    private manipulateDatePostData(postData: any, field: any, key: any) {
        if (postData[key] === undefined) {
            return;
        }
        if (this.isBookingRequestDateField(postData.requestType, field.uiType)) {
            postData[key] = this.dateUtils.convertBookingRequestDateANDTimeTypeToIlsDate(postData[key]);
        } else if (field.uiType === FormBuilderEnums.UI_TYPE.DATE) {
            postData[key] = this.dateUtils.convertDateTypeToIlsDateString(postData[key]);
        } else if (field.uiType === FormBuilderEnums.UI_TYPE.DATE_AND_TIME) {
            postData[key] = this.dateUtils.convertDateANDTimeTypeToIlsDate(postData[key]);
        }
    }

    private getFieldByName(form, name) {
        let matchedFields = filter(form, (el) => {
            return el.name === name;
        });
        return matchedFields[0];
    }

    public isCheckAvailabilityEnabledForForm() {
        return this.serviceType === 'AlmaResourceSharing' && this.requestService.isCheckAvailabilityEnabled;
    }

    public isCheckAvailabilityMandatoryForForm() {
        return this.isCheckAvailabilityEnabledForForm() && this.requestService.isCheckAvailabilityMandatory;
    }


    get displayFindDescription(): boolean {
        return (this.serviceType === 'AlmaResourceSharing' &&
            ((this.requestService.formData.citationType === 'BK' && this.requestService.isBookFindItemDescriptionsEnabled) ||
                (this.requestService.formData.citationType === 'CR' && this.requestService.isArticleFindItemDescriptionsEnabled)));
    }


    private checkAvailability() {
        this.itemAvailabilityCheckInProgress = true;
        this.availabilityCheckRan = true;
        this.formInputChangedSinceLastAvailabilityCheck = false;
        this.requestService.checkAvailability().then((response: { data: boolean }) => {
            this.itemAvailability = response.data === null ? undefined : response.data;
        }, (err) => {
            this.itemAvailability = undefined;
        }).finally(() => {
            this.itemAvailabilityCheckInProgress = false;
        });
    }

    public isSubmitDisabledDueItemAvailability() {
        return this.isCheckAvailabilityMandatoryForForm() && (this.itemAvailabilityCheckInProgress || this.itemAvailability === false
            || (this.blankService === 'AlmaResourceSharing' && !this.availabilityCheckRan));
    }

    private findItemLevelDescriptions() {
        this.requestService.form.filter(field => {
            return field.key == 'bookDescription'
        })[0].uiType = 'hidden';
        this.requestService.form.filter(field => {
            return field.key == 'articleDescription'
        })[0].uiType = 'hidden';
        this.requestService.formData.bookDescription = undefined;
        this.requestService.formData.articleDescription = undefined;
        this.itemDescriptionsNotEmpty = false;
        this.findItemLevelDescriptionsInProgress = true;
        this.findItemLevelDescriptionsRan = true;
        this.requestService.findItemLevelDescriptions().then((response: { data: String }) => {
            this.itemDescriptionsNotEmpty = (response.data && response.data.length) > 0 ? true : false;
            this.requestService.formFields.filter(formField => {
                return formField.label === 'almaResourceSharing.description'
            }).forEach(field => {
                field.options = response.data === null || response.data.length < 1 ? undefined : this.convertDescriptionData(response.data)
                if (field.key === 'bookDescription' && this.requestService.isBookFindItemDescriptionsEnabled) {
                    field.uiType = FormBuilderEnums.UI_TYPE.DROP_DOWN;
                }
                if (field.key === 'articleDescription' && this.requestService.isArticleFindItemDescriptionsEnabled) {
                    field.uiType = FormBuilderEnums.UI_TYPE.DROP_DOWN;
                }
            });


        }, (err) => {
            this.itemDescriptionsNotEmpty = false;
        }).finally(() => {
            this.findItemLevelDescriptionsInProgress = false;
        });
    }

    private handleSpecificChapterPages(newData, oldData) {
        if (newData === 'Yes') {
            if (FormBuilderService.getFormatOption(this.requestService.form, 'DIGITAL')) {
                this.requestService.formData.format = 'DIGITAL';
            }
            const chapter = this.requestService.mappingTablesCache.findByProperties(this.requestService.mappingTablePerService.AlmaResourceSharing, {
                source2: 'chapter',
                source3: 'book',
                target: 'Yes'
            }).length > 0 && this.requestService.form.filter(field => {
                return field.key == 'chapter'
            }).length > 0;
            if (chapter) {
                this.requestService.form.filter(field => {
                    return field.key == 'chapter'
                })[0].uiType = FormBuilderEnums.UI_TYPE.TEXT;
            }
            const pages = this.requestService.mappingTablesCache.findByProperties(this.requestService.mappingTablePerService.AlmaResourceSharing, {
                source2: 'pagesToPhotocopy',
                source3: 'book',
                target: 'Yes'
            }).length > 0 && this.requestService.form.filter(field => {
                return field.key == 'pagesToPhotocopy'
            }).length > 0;
            if (pages) {
                this.requestService.form.filter(field => {
                    return field.key == 'pagesToPhotocopy'
                })[0].uiType = FormBuilderEnums.UI_TYPE.TEXT;
            }
        } else {
            if (FormBuilderService.getFormatOption(this.requestService.form, 'PHYSICAL')) {
                this.requestService.formData.format = 'PHYSICAL';
            }
            const chapter = this.requestService.form.filter(field => {
                return field.key == 'chapter'
            });
            if (chapter.length > 0) {
                chapter[0].uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
            }
            const pages = this.requestService.form.filter(field => {
                return field.key == 'pagesToPhotocopy'
            });
            if (pages.length > 0) {
                pages[0].uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
            }
        }
        this.requestService.updateForm();
    }

    private handleFormatByCitationType(newCitationTypeData, oldCitationTypeData, specificChapterPagesData) {
        if (FormBuilderService.getFormatOption(this.requestService.form, 'DIGITAL') && newCitationTypeData === 'CR') {
            this.requestService.formData.format = 'DIGITAL';
        } else if (FormBuilderService.getFormatOption(this.requestService.form, 'PHYSICAL') && newCitationTypeData === 'BK' && specificChapterPagesData !== 'Yes') {
            this.requestService.formData.format = 'PHYSICAL';
        }
    }

    public isCheckAvailabilityButtonDisabled() {
        return this.itemAvailability === true && !this.formInputChangedSinceLastAvailabilityCheck;
    }

    public getRequiredLabel(field) {
        if (this.isCopyrightField(field)) {
            return "nui.mandatory.copyright";
        }
        return (field.label !== undefined && field.label.length > 0) ? field.label : (field.options !== undefined && field.options.length > 0) ? field.options[0].label : '';
    }

    private isCopyrightField(field) {
        return field.name !== undefined && (field.name === 'copyrightDeclaration' || field.name === 'copyrights' || field.name === 'copyright');
    }

    private isBookingRequestDateField(requestType, fieldType): boolean {
        return requestType === 'booking' &&
            (fieldType === FormBuilderEnums.UI_TYPE.DATE ||
                fieldType === FormBuilderEnums.UI_TYPE.DATE_AND_HOURS ||
                fieldType === FormBuilderEnums.UI_TYPE.DATE_AND_TIME);
    }

    private onFormInputChange(newFormData, oldFormData) {
        console.log('input changed');
        if (newFormData.format !== oldFormData.format) {
            this.findItemLevelDescriptions();
            if (newFormData.format === 'DIGITAL' && this.blankService === 'AlmaResourceSharing' && isNgrs()) {
                console.log('blankService - calc default digital owner and pickup information');
                this.updateDigitalDefaultOwnerAndPickupInformation(newFormData);
            }
        }
        if (newFormData.specificChapterPages !== oldFormData.specificChapterPages && (newFormData.specificChapterPages !== 'Y' && newFormData.specificChapterPages !== undefined)) {
            this.handleSpecificChapterPages(newFormData.specificChapterPages, oldFormData.specificChapterPages);
        }
        if (oldFormData.citationType && newFormData.physicalServicesResultId &&
            oldFormData.physicalServicesResultId === newFormData.physicalServicesResultId && newFormData.citationType !== oldFormData.citationType) {
            this.handleFormatByCitationType(newFormData.citationType, oldFormData.citationType, newFormData.specificChapterPages);
        }

        let calcQueueFormField = this.form.filter(el => el.key == "calculateQueueButton")[0];
        if (calcQueueFormField !== undefined && calcQueueFormField.options !== undefined) {
            calcQueueFormField.options.numInQueue = undefined
        }
        this.formInputChangedSinceLastAvailabilityCheck = true;
    }

    public detectMobile() {
        if (this.mediaQueries.xs || this.mediaQueries.sm) {
            return true;
        }
        return false;
    }

    public buttonClicked(fieldName) {
        switch (fieldName) {
            case 'calculateQueueButton':
                let service: PrimoResponse.Ils.IRequestService = cloneDeep(this.requestService.service);
                let postData = cloneDeep(this.formData);
                service['link-to-service'] = this.getLinkToServiceForPlaceInQueue(service);
                this.manipulatePostData(postData);
                this.opacService.makeIlsCall(service, postData, 'POST').then(
                    res => {
                        this.form.filter(el => el.key == "calculateQueueButton")[0].options.numInQueue = res;
                    }
                )
                break;

            case 'doi':
            case 'pmid':
                this.autoFill(fieldName)
                break;

            default:
                break;
        }
    }

    private getLinkToServiceForPlaceInQueue(service) {
        return service['link-to-service'].includes('titleServices') ?
            service['link-to-service'].replace('titleServices', 'calculatePlaceInQueue') :
            service['link-to-service'].includes('itemServices') ?
                service['link-to-service'].replace('itemServices', 'calculatePlaceInQueue') : null;
    }

    private convertDescriptionData(data: object) {
        let jsonData: object [] = [];
        let jsonfield = {};
        data.forEach(desc => {
            jsonData.push(
                {
                    'label': desc,
                    'value': desc
                })
        });
        return jsonData;
    }

    private updateDigitalDefaultOwnerAndPickupInformation(newForm: object) {
        this.requestService.getDigitalDefaultOwnerAndPickupInformation().then((response) => {
            if (response && response.data && response.data["services-arr"] && response.data["services-arr"].services[0]) {
                if(newForm.owner === response.data["services-arr"].services[0].owner){
                    return;
                }
                response.data["services-arr"].services[0].citationType = newForm.citationType;
                if (newForm.citationType === 'BK' &&
                    (newForm.specificChapterPages === true || newForm.specificChapterPages === 'Yes' || newForm.specificChapterPages === 'Y')) {
                    response.data["services-arr"].services[0].bookChapter = true;
                }

                this.requestService.setupNewForm(this.requestService.service, response.data);
                this.requestService.formData.format = 'DIGITAL';

            }

        }, (err) => {
            console.log('Failed to get digital default owner and pickup information', err);
        });
    }

    private sendAnalytics() {
        let payload = this.getAnalyticsPayload();
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.CREATE_PHYSICAL_REQUEST, payload);
    }

    private getAnalyticsPayload() {
        return {
            "Request Type": this.getAnalyticsRequestType(),
            "Request Action Type": "Send",
            "Record ID": get(this.item, 'pnx.control.recordid[0]'),
            "Record Title": get(this.item, 'pnx.display.title[0]'),
            "Resource Type": get(this.item, 'pnx.display.type[0]'),
            "Request Material Type": this.formData.materialType,
            "Level Type": this.getLevelType(),
        }
    }

    private getAnalyticsRequestType() {

        const reqType = this.formData.requestType != null || undefined? this.formData.requestType : this.serviceType;

        switch (reqType) {
            case "hold" :
                return "Holding Request";
            case "booking" :
                return "Booking Request";
            case "AlmaDigitization":
                return "Digitization Request";
            case "AlmaPurchaseRequest":
                return "Purchase Request";
            case "AlmaItemDigitization":
                return "Digitization Request";
            case  "AlmaItemRequest":
                return "Holding or Booking Request";
            case "AlmaResourceSharing":
                return "Resource Sharing"
            default:
                return this.serviceType;
        }
    }

    private getLevelType() {
        let currUrl = window.location.toString();
        let page = currUrl.substring(currUrl.lastIndexOf('\/') + 1, currUrl.lastIndexOf('\?')); //get the page name

        if (isEqual(page, 'blankIll'))
            return 'Blank Form';
        else if (isEqual(page, 'purchaseRequest'))
            return 'Blank Form';
        else if (isEqual(this.serviceType, "AlmaItemDigitization") || isEqual(this.serviceType, "AlmaItemRequest"))
            return "Item Level";
        else return "Title Level";
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/request.directive.ts